import React from 'react';

export default function FileIcon(props) {
  return (
    <svg width='32' height='32' viewBox='0 0 32 32' {...props}>
      <path
        d='M14 18a1 1 0 0 1 0-2h4a1 1 0 0 1 0 2h-1v4a1 1 0 0 1-2 0v-4h-1zm7-6a1 1 0 0 1 0 2H11a1 1 0 0 1 0-2h10zm3-4a1 1 0 0 1 0 2H8a1 1 0 1 1 0-2h16z'
        fill='currentColor'
        fillRule='evenodd'
      />
    </svg>
  );
}
